
import React, {
  useState,
  useEffect,
  useImperativeHandle,
  useCallback,
} from 'react'
import {
  GoogleMap,
  LoadScriptNext,
  InfoBox,
  Marker,
} from '@react-google-maps/api'
import './inject.css'
import { resolveIcon } from '../../utils/Mapa/renderResults'
import useMedia from 'use-media'
import Icon from '../Icons'
import { BubbleMarker } from './styles'

const GOOGLE_API_KEY = 'AIzaSyB59WWNAkbuPVjPlX2aYUERAlrvazQo1uM'

const containerStyle = {
  width: '100%',
  height: '100vh',
  zIndex: 0,
}

const mapOptions = {
  fullscreenControl: false,
  streetViewControl: false,
  mapTypeControl: false,
  rotateControl: true,
  minZoom: 4,
  maxZoom: 17,
}

const infoBoxOptions = {
  closeBoxURL: '',
  enableEventPropagation: true,
}

const BRASILIA = {
  lat: -15.721387,
  lng: -48.0774421,
}
const MapContainer = React.forwardRef((props, ref) => {
  const [map, setMapApi] = useState(null)
  const [google, setGoogle] = useState(null)
  const [results, setResults] = useState(null)

  const onMapUnmount = useCallback(() => {
    setMapApi(null)
  }, [])

  useImperativeHandle(ref, () => ({
    centerMap() {
      const newLatLng = new google.maps.LatLng(
        props.latlong.latitude,
        props.latlong.longitude
      )
      map.panTo(newLatLng)
      map.setZoom(10)
    },
  }))

  const isMobileSM = useMedia({ maxWidth: 360 })
  const isMobileMD = useMedia({ maxWidth: 449 }) 
  const isMobileMD2 = useMedia({ maxWidth: 641 })
  const isMobile = useMedia({ maxWidth: 767 })

  let mapContainerHeight = containerStyle.height
  if (isMobileSM) mapContainerHeight = '96vh'
  else if (isMobileMD) mapContainerHeight = '98.5vh'
  else if (isMobileMD2) mapContainerHeight = '101.3vh'
  else if (isMobile) mapContainerHeight = '104vh'

  useEffect(() => {
    if (!!props.results && props.results !== results) {
      setResults(props.results)
    }
  }, [props.results, results])

  const onMapReady = useCallback((_map) => {
    // bypass user position or default
    const target = props.latlong
      ? {
          lat: props.latlong.latitude,
          lng: props.latlong.longitude,
        }
      : BRASILIA

    _map.panTo(target)

    setGoogle(window.google)
    setMapApi(_map)

    if (typeof props.onReady === 'function') {
      props.onReady(true)
    }
  }, [props])

  useEffect(() => {
    if (!!results && !!results.length && !!google) {
      // test for selected item or showing all results
      const selected = results.reduce((acc, item) => {
        if (item.selected === true) acc = item
        return acc
      }, null)

      try {
        if (selected) {
          map.setCenter({
            lat: selected.location.latitude,
            lng: selected.location.longitude,
          })
          map.setZoom(10)
        } else {
          const boundbox = new google.maps.LatLngBounds()
          results.forEach((item) => {
            const latlng = {
              lat: item.location.latitude,
              lng: item.location.longitude,
            }
            boundbox.extend(latlng)
          })

          if (isMobile) {
            map.fitBounds(boundbox, {
              bottom: 200,
              top: 200,
            })
          } else {
            map.fitBounds(boundbox, {
              left: 450,
              right: 100,
              bottom: 100,
            })
          }
        }
      } catch (err) {
        console.error(err)
      }
    }
  }, [results, google, isMobile, map])

  const handleClickMarker = (data) => {
    if (typeof props.onSelectMarker === 'function') {
      props.onSelectMarker({
        latitude: data.location.latitude,
        longitude: data.location.longitude,
      })
    }
  }

  const UserLocationMarker = () => {
    if (props.latlong) {
      const userLocation = {
        lat: props.latlong.latitude,
        lng: props.latlong.longitude,
      }
      return <Marker position={userLocation} />
    }
    return null
  }

  const addMark = (data, index) => {
    if (!data && !google) {
      return false
    }
    const position = {
      lat: data.location.latitude,
      lng: data.location.longitude,
    }
    return (
      <InfoBox
        key={`marker-${index}-${data.id}`}
        options={{
          pixelOffset: window.google.maps.Size(-26, -59),
          ...infoBoxOptions,
        }}
        position={position}
      >
        <div style={{ height: '59px' }}>
          <BubbleMarker
            onClick={() => handleClickMarker(data)}
            selected={data.selected}
          >
            <Icon name={resolveIcon(data.category)} alt={data.category} />
          </BubbleMarker>
        </div>
      </InfoBox>
    )
  }

  return (
    <LoadScriptNext googleMapsApiKey={GOOGLE_API_KEY}>
      <GoogleMap
        mapContainerStyle={{ ...containerStyle, height: mapContainerHeight }}
        zoom={4}
        center={BRASILIA}
        onLoad={onMapReady}
        onUnmount={onMapUnmount}
        clickableIcons={false}
        options={mapOptions}
        tilt={45}
        mapTypeId="hybrid"
      >
        {Array.isArray(props.results) && props.results.map(addMark)}
        <UserLocationMarker />
      </GoogleMap>
    </LoadScriptNext>
  )
})

export default React.memo(MapContainer)
